import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import './index.css';
import App from './App';
import { store } from './store/store';
import { LanguageProvider } from './contexts/LanguageContext';
import { ThemeProvider } from './contexts/ThemeContext';

// Suppress unhandled Axios rejection noise in production
window.addEventListener('unhandledrejection', (event) => {
  const isAxiosError = event.reason?.isAxiosError === true ||
    event.reason?.config?.baseURL ||
    event.reason?.config?.url;
  if (isAxiosError) {
    event.preventDefault();
    if (process.env.NODE_ENV === 'development') {
      console.warn('[Axios unhandled rejection]', event.reason?.message ?? event.reason);
    }
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <LanguageProvider>
        <ThemeProvider>
          <App />
        </ThemeProvider>
      </LanguageProvider>
    </Provider>
  </React.StrictMode>
);